// src/services/leadLogService.js
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/lead-logs`;
const getAuthToken = () => localStorage.getItem('token');

// Set the Authorization header with the token
const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

// Function to log communication events (SMS, Email, etc.)
export const logCommunication = async (leadId, action, description, userId) => {
  try {
    const response = await axios.post(
      `${API_URL}`,
      {
        leadId,
        action: `${action} Communication`,
        description,
        userId,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error logging communication:', error);
    throw error;
  }
};
